/**
 * Searcher types.
 */
export enum SearcherType {
  /**
   * Fuzzy searcher type.
   */
  Fuzzy = 'fuzzy',

  /**
   * Substring searcher type.
   */
  Substring = 'substring',

  /**
   * Prefix searcher type.
   */
  Prefix = 'prefix'
}
